module.exports = __webpack_public_path__ + "static/media/AMAZON_POLISH_EWA.5b14c5df.mp3";